import React from 'react';
import jwt_decode from 'jwt-decode';
import { useHistory } from 'react-router-dom';

import * as Cookies from '../utils/cookies';
import Loading from './../layouts/Loading/Loading';
import { useGetAppLinks } from '../hooks/useGetAppLinks';
import { getUserPlayerInfo } from '../api/getUserPlayerInfo';


function Auth({ user, setUser, children }) {
  const history = useHistory();

  const token = Cookies.getToken();

  const { signIn } = useGetAppLinks();
  React.useEffect(() => {

    const isValidToken = checkedToken => {
      const decoded = jwt_decode(checkedToken);

      const isUpToDate = decoded.exp > (new Date().getTime() + 86400000) / 1000;
      const isUser = decoded.user_id;

      return isUser && isUpToDate;
    };

    if (!token || !isValidToken(token)) {

      token && Cookies.removeToken();
      history.push(signIn);
    } else if (token && !user) {
      getUserPlayerInfo().then(data => {
        if (data.error) {
          if (data.error.response && data.error.response.status === 401) {
            Cookies.removeToken();
              history.push(signIn);
          }
        } else {
          setUser(data);
        }
      });
    } else if (token && user) {

      if (isValidToken(token) ) {
      } else {

        Cookies.removeToken();
        history.push(signIn);
      }
    }
  }, [history, token, user, setUser]);

  return <>{user ? children : <Loading />}</>;
}

export default Auth;


